import { BaseDO } from './BaseDO';

export class RecordsDataDO extends BaseDO {
  records: RecordDO[];

  protected getPrimitivePropertyKeys(): string[] {
    return [
      'records'
    ];
  }

  buildFromObject(object: object) {
    super.buildFromObject(object);

    if (object['records']) {
      this.records = object['records'].map(recordData => {
        const record = new RecordDO();
        record.buildFromObject(recordData);
        return record;
      });
    }
  }
}

export class RecordDO extends BaseDO {
  id: string;
  fields: {
    name: string,
    notes: string,
    fullDescription: string,
    plusVotes: string,
    minusVotes: string,
    image: string
  };

  protected getPrimitivePropertyKeys(): string[] {
    return [
      'id',
      'fields'
    ];
  }
}
